module.exports = __webpack_public_path__ + "img/x.c4f6753a.svg";